// Packages
import React from "react"
import { Script } from "gatsby"

// Components
import LayoutContent from "@components/global/layout-content"

// Hooks
import useClientSideOnly from "@hooks/use-client-side-only"

// Stores
import { useBankerStore } from "@store/useBankerStore"

// Utils
import { bankersWithWebsites } from "@utils/mb"

const states = require("us-state-converter")

export let bankerData
function LayoutWalledMB(props) {
  // bankerData = bankersWithWebsites.find(mb => {
  //   return (
  //     props.params.mb === mb.slug ||
  //     props.pageContext.slug === mb.slug ||
  //     props.path?.split("/")[1] === mb.slug
  //   )
  // })

  const isMounted = useClientSideOnly()

  bankerData = useBankerStore(state => state.getBanker({ ...props, isMounted }))

  const newProps = {
    ...props,
    bankerData,
    isMounted,
  }

  let personSchema
  if (bankerData) {
    personSchema = {
      "@context": "https://schema.org",
      "@type": "Person",
      name: bankerData.name,
      jobTitle: bankerData.jobTitle,
      image: bankerData.headshot.url,
      url: `https://www.atlanticbay.com${bankerData.slug}`,
    }
    if (bankerData.phone)
      personSchema.telephone = `+1${bankerData.phone.replace(/\D/g, "")}`
    if (bankerData.email) personSchema.email = bankerData.email
    if (bankerData.nmls)
      personSchema.identifier = {
        "@type": "PropertyValue",
        propertyID: "NMLS ID",
        value: bankerData.nmls,
      }

    let sameAs = []
    if (bankerData.facebook) sameAs.push(bankerData.facebook)
    if (bankerData.linkedin) sameAs.push(bankerData.linkedin)
    if (bankerData.zillow) sameAs.push(bankerData.zillow)
    if (bankerData.instagram) sameAs.push(bankerData.instagram)
    if (bankerData.youtube) sameAs.push(bankerData.youtube)

    if (sameAs.length > 0) personSchema.sameAs = sameAs

    const areaServed = bankerData.licenses?.map(license => ({
      "@type": "State",
      name: states(license).name,
    }))

    if (areaServed) personSchema.areaServed = areaServed
  }

  return (
    <>
      <LayoutContent {...newProps} />
      {personSchema && (
        <Script type="application/ld+json">
          {JSON.stringify({
            ...personSchema,
            worksFor: {
              "@id": "https://www.atlanticbay.com/#organization",
            },
            // knowsAbout: ["FHA Loans", "VA Loans", "First-Time Buyers"],
          })}
        </Script>
      )}
    </>
  )
}

export default LayoutWalledMB
